import { DP_DASHBOARD } from "../../../constants/Constant";
import Spinner from "../../../utils/Spinner";
import BIWidgetOverview from "./BIWidgetOverview";

const BIWidgetData = (props) => {

  return (
    <>
      {
        props.catalogData?.catalogLoading ? (
          <div className="justify-content-md-center">
            <Spinner
              text="BI Product"
            />
          </div>
        ) : (<BIWidgetOverview
          catalogData={props.catalogData}
          name="Data Products - Dashboard & Reports"
          compType={DP_DASHBOARD}
        />)}

    </>
  );
};

export default BIWidgetData;
